export const iconFontAwesomeSpinnersRotate = (
	<i className="fa-solid fa-rotate"></i>
);
